import { render, staticRenderFns } from "./TreatmentSessionComments.vue?vue&type=template&id=c27c072c"
import script from "./TreatmentSessionComments.vue?vue&type=script&lang=js"
export * from "./TreatmentSessionComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports